import axios from "axios";
import { APIEndpoint } from "@/constants/config";

const http = axios.create({
  baseURL: APIEndpoint,
  headers: {
    Accept: "application/json",
  },
  timeout: 30000,
});

export const setAuthToken = (token) => {
  if (token) {
    http.defaults.headers.common.Authorization = `Token ${token}`;
  } else {
    delete http.defaults.headers.common.Authorization;
  }
};

function clearStoredAuth() {
  delete http.defaults.headers.common.Authorization;
  try {
    localStorage.removeItem("user");
  } catch (e) {
    /* ignore */
  }
}

http.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error && error.response && error.response.status;
    // Stale/invalid token → clear so public endpoints work again
    if (status === 401) {
      clearStoredAuth();
    }
    return Promise.reject(error);
  }
);

export default http;
